import {
    Box, Typography, Button, Stack, Paper, TableContainer, Menu, MenuItem, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Snackbar,
    Alert,
    Tooltip,
    Chip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useState, useEffect } from "react";
import axios from "axios";
import { USER_ACTIONS, isAllowedAction } from "../config/auth";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import InfoIcon from '@mui/icons-material/Info';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { parseErrorData } from "../config/commonFunctions";
import { PARTICIPANT_CONNECTORS, PARTICIPANT_REQUEST_DELETION, PARTICIPANT_EVALUATE_DELETION, CONNECTOR_EXPORT_API } from "../config/settings";
import ComposeModal from "../messages-notifications/ComposeModal";
import { messages } from "../config/messages";

export default function ParticipantListOfConnectors(props) {
    const navigate = useNavigate();
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [connectors, setConnectors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuConnector, setMenuConnector] = useState(null);
    const [selectedConnector, setSelectedConnector] = useState(null);
    const [dialogAdminDeleteOpen, setDialogAdminDeleteOpen] = useState(false);
    const [dialogRequestDeleteOpen, setDialogRequestDeleteOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [deleteRequestReason, setDeleteRequestReason] = useState("");
    const [deleteRequestAdminReason, setDeleteRequestAdminReason] = useState("");
    const [dialogRequestAdminDeleteOpen, setDialogRequestAdminDeleteOpen] = useState("");
    const [deleteDecision, setDeleteDecision] = useState("");
    const [composeOpen, setComposeOpen] = useState(false);

    const participant = props.participant;
    // console.log(participant);
    const open = Boolean(anchorEl);
    // Snackbar state
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const selectedParticipantNames = rowSelectionModel.map((uuid) => {
        const row = connectors.find((c) => c.uuid === uuid);
        // Explicitly enforce the `enabled === true && deleted === false` rule right here
        if (row && row.enabled === true && row.deleted === false) {
            return row.name;
        }
        return null;
    }).filter(Boolean);

    const requestedColors = {
        REQUESTED_DELETION: "warning",
        NO_REQUEST: "default",
    };

    useEffect(() => {
        fetchConnectors();
    }, []);

    const handleExport = async () => {
        try {
            // Map selected UUIDs to original IDs
            const selectedIds = rowSelectionModel.map((uuid) => {
                const row = connectors.find((c) => c.uuid === uuid);
                return row?.id; // use row.id, or adjust to the real field name
            }).filter(Boolean);
            if (selectedIds.length === 0) {
                console.warn("No valid IDs found for export.");
                return;
            }
          const url = `${CONNECTOR_EXPORT_API}?requested_ids=${selectedIds.join(',')}`;
          const response = await axios.get(url, { responseType: 'blob' });
          if (response.data && response.data.size > 0) {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'connectors.csv';
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);
              if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1];
              }
            }
            const blobUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);

          } else {
            console.warn("No data received for export.");
          }
        } catch (err) {
          console.error("Error during export:", err);
          const errorMessage =
            parseErrorData(err.response?.data) || "Failed to export connectors.";
        }
      };

    const handleEdit = (connector) => {
        console.log(connector);
        navigate(`/connector-form/${connector.id}`, { state: { connector } });
    };

    const handleClick = (event, connector) => {
        setAnchorEl(event.currentTarget);
        // console.log(connector);
        setMenuConnector(connector);
    };

    const handleRequestAdminDelete = () => {
        setSelectedConnector(menuConnector); // Store the selected participant for deletion
        setDialogRequestAdminDeleteOpen(true); // Open the confirmation dialog
        handleClose(); // Close the menu after selecting AdminDelete
    };

    const handleDialogRequestAdminDeleteClose = () => {
        setDialogRequestAdminDeleteOpen(false);
    };

    const handleAdminDelete = () => {
        setSelectedConnector(menuConnector); // Store the selected participant for deletion
        setDialogAdminDeleteOpen(true); // Open the confirmation dialog
        handleClose(); // Close the menu after selecting AdminDelete
    };

    const handleDialogAdminDeleteClose = () => {
        setDialogAdminDeleteOpen(false);
    };

    const handleRequestConnectorDelete = () => {
        setSelectedConnector(menuConnector); // Store the selected participant for deletion
        setDialogRequestDeleteOpen(true); // Open the confirmation dialog
        handleClose(); // Close the menu after selecting AdminDelete
    };

    const handleDialogRequestDeleteClose = () => {
        setDialogRequestDeleteOpen(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };

    const fetchConnectors = async () => {
        try {
            const response = await axios.get(PARTICIPANT_CONNECTORS);
            setConnectors(response.data);
            // console.log(response.data);
            setLoading(false);
        } catch (err) {
            setError(err);
            setLoading(false);
        }
    };

    // Function to handle actual deletion request
    const confirmAdminDelete = async () => {
        try {
            const payload = {
                reason: reason,
            };

            await axios.delete(
                `${PARTICIPANT_CONNECTORS}${selectedConnector.id}/`, { data: payload } // must end with /
            );
            // console.log("will delete connector with id", selectedConnector.id)
            setDialogAdminDeleteOpen(false);
            await fetchConnectors(); // Refresh the participant list after deletion
            setSnackbarMessage(messages.participantDetailsRequestDeclineDeleteSnackbarSuccess);
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
        } catch (err) {
            console.error("Error during deletion:", err);
            const errorMessage =
                parseErrorData(err.response?.data) || messages.participantDetailsRequestDeclineDeleteSnackbarError;
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    const confirmRequestDelete = async () => {
        try {
            const payload = {
                connectorID: menuConnector.id,
                reason: deleteRequestReason,
            };
            await axios.put(PARTICIPANT_REQUEST_DELETION, payload);
            setDialogRequestDeleteOpen(false);
            await fetchConnectors();
            setSnackbarMessage(messages.participantDetailsRequestDeleteSnackbarSuccess);
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            handleClose();
        } catch (err) {
            console.error("Error during request:", err);
            const errorMessage =
                parseErrorData(err.response?.data) || messages.participantDetailsRequestDeclineDeleteSnackbarError;
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity("error");
            setSnackbarOpen(true); // Show snackbar on error
        }
    };

    const confirmRequestAdminDelete = async () => {
        try {
            const payload = {
                connectorID: menuConnector.id,
                reason: deleteRequestAdminReason,
                approved: deleteDecision === "true" ? true : false,
            };
            await axios.put(PARTICIPANT_EVALUATE_DELETION, payload);
            setDialogRequestAdminDeleteOpen(false);
            await fetchConnectors();
            setSnackbarMessage(messages.connectorEvaluateDeleteSnackbarSuccess);
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            handleClose();
        } catch (err) {
            console.error("Error during connector action:", err);
            const errorMessage =
                parseErrorData(err.response?.data) || messages.connectorEvaluateDeclineDeleteSnackbarError;
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity("error");
            setSnackbarOpen(true); // Show snackbar on error
        }
    };

    const renderConnectorDates = (row) => {
        const dateFields = [
            { label: "Created", value: row.created_at },
            { label: "Updated", value: row.updated_at },
            { label: "Enabled", value: row.enabled_at },
            { label: "Disabled", value: row.disabled_at },
            { label: "Deleted", value: row.deleted_at },
        ];

        return (
            <Box sx={{ whiteSpace: 'pre-line' }}>
                {dateFields
                    .filter(field => field.value)
                    .map(field => `${field.label}: ${field.value}`)
                    .join('\n')}
            </Box>
        );
    };

    if (!connectors || connectors.length === 0) {
        return <></>;
    }
    const canSeeActions =
        isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR) ||
        isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY);

    const columns = [
        {
            field: "name", headerName: "Connector name", flex: 1,
            renderCell: (params) => (
                <>
                    <div style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.5,
                        width: '100%',
                    }}>
                        <Typography variant="body1">{params.row.name}</Typography>
                    </div>
                    <div>
                        <Typography variant="caption" className="grey-font-light" > {renderConnectorDates(params.row)}</Typography>
                    </div>

                </>
            )
        },
        { field: "participant_name", headerName: "Participant name", flex: 0.9 },
        { field: "enabled", headerName: "Enabled", flex: 0.5, renderCell: (params) => (params.value ? "true" : "false") },
        { field: "is_up", headerName: "Is Up", flex: 0.5, renderCell: (params) => (params.value ? "true" : "false") },
        { field: "version_info", headerName: "Version", flex: 0.5 },
        {
            field: "deleted",
            headerName: "Is Deleted", flex: 0.5, renderCell: (params) => (
                <Chip label={params.value ? "true" : "false"} variant="contained" color={params.value === true ? "warning" : "default"} />
            )
        },
        {
            field: "request_status",
            headerName: "Request status",
            flex: 1.1,
            renderCell: (params) => (
                <Chip label={params.row?.request_status} variant="outlined" color={requestedColors[params.row?.request_status] || "default"} />
            ),
        },
        { field: "connector_url", headerName: "Connector URL", flex: 1.4 },
        ...(canSeeActions
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    sortable: false,
                    filterable: false,
                    flex: 0.5,
                    renderCell: (params) => (<>
                        <Button id="basic-button" aria-controls={open ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} onClick={(e) => handleClick(e, params.row)}>
                            {messages.actions}
                        </Button>
                        <Menu id="basic-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                            <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: "bold", textTransform: "uppercase", color: "text.secondary" }}>
                                {messages.connectorManage}
                            </Typography>
                            <MenuItem
                                onClick={() => handleEdit(menuConnector)}
                                disabled={menuConnector?.deleted === true || participant?.management?.approval_status === "WITHDRAWN" || participant?.management?.approval_status === "SUSPENDED"}>
                                <EditIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                                {messages.connectorEdit}
                            </MenuItem>
                            {isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) &&
                                (["NO_REQUEST"].includes(menuConnector?.request_status) && menuConnector?.is_up === false && menuConnector?.deleted === false) &&
                                <MenuItem onClick={() => handleAdminDelete(menuConnector)} disabled={false} >
                                    <DeleteForeverIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                                    {messages.delete}
                                </MenuItem>
                            }
                            {isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) &&
                                (["REQUESTED_DELETION"].includes(menuConnector?.request_status) && menuConnector?.deleted === false) &&
                                <MenuItem onClick={() => handleRequestAdminDelete(menuConnector)} disabled={false} >
                                    <DeleteForeverIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                                    {messages.connectorsRequestApproveRejectDelete}
                                </MenuItem>
                            }
                            {(isAllowedAction(USER_ACTIONS.UPDATE_OWN_CONNECTOR)) &&
                                (["NO_REQUEST"].includes(menuConnector?.request_status) && menuConnector?.is_up === false && menuConnector?.deleted === false) &&
                                <MenuItem onClick={() => handleRequestConnectorDelete(menuConnector)} disabled={["REQUESTED_DELETION"].includes(menuConnector?.request_status)} >
                                    <DeleteForeverIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                                    {messages.connectorsRequestDelete}
                                </MenuItem>
                            }
                        </Menu>
                    </>
                    ),
                },
            ]
            : []),
    ];

    return (
        <>
            <Grid container alignItems="stretch">
                <TableContainer
                    component={Paper}
                    style={{ padding: "20px", marginTop: "1em" }}
                >
                    <Stack spacing={2}>
                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                            <Grid item>
                                <Typography variant="h4" sx={{ mb: 1, mt: 5, color: "#213270" }}>
                                    {messages.connectorListPageTitle}
                                </Typography>
                                <Typography variant="h5" sx={{ mb: 2, mt: 2 }}>
                                    {messages.connectorListPageSubTitle}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                                    {(isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) ||
                                        isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY))
                                        && <Button variant="contained" onClick={handleExport}>
                                            {messages.connectorListExportButton}
                                        </Button>}
                                    {isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => setComposeOpen(true)}
                                            startIcon={<ForwardToInboxIcon />}
                                            disabled = {selectedParticipantNames.length === 0}
                                        >
                                            {messages.ListofConnectors_Top_broadcast_button} ({selectedParticipantNames.length})
                                        </Button>
                                    )}
                                    <Tooltip title={messages.boradcastInfoMessageTootip}><InfoIcon color="success"/></Tooltip>
                                </Stack>
                            </Grid>
                        </Grid>

                        {composeOpen && (
                            <ComposeModal
                                selectedConnectors={selectedParticipantNames}
                                onClose={() => setComposeOpen(false)}
                                onSent={() => {
                                    setComposeOpen(false);
                                    setRowSelectionModel([]);
                                    // Optional: trigger list refresh if needed
                                }}
                            />
                        )}
                        <Box sx={{ width: "100%" }}>
                            <DataGrid
                                rows={connectors}
                                columns={columns}
                                getRowId={(row) => row.uuid}
                                loading={loading}
                                pageSize={5}
                                checkboxSelection={isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) || isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY)}
                                onRowSelectionModelChange={(newRowSelectionModel) => {
                                    setRowSelectionModel(newRowSelectionModel);
                                }}
                                rowSelectionModel={rowSelectionModel}
                                disableRowSelectionOnClick
                                getRowHeight={() => 100}
                                sx={{
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                    },
                                }}
                            />
                            {(isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) ||
                                isAllowedAction(USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY))
                                && <Button variant="contained" onClick={handleExport} style={{ marginTop: '16px' }}>
                                    {messages.connectorListExportButton}
                                </Button>}
                        </Box>
                    </Stack>
                    {/* Delete ADMIN confirmation dialog */}
                    <Dialog open={dialogAdminDeleteOpen} onClose={handleDialogAdminDeleteClose}>
                        <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.connectorDeleteAction}</Typography></DialogTitle>
                        <DialogContent>
                            <Typography variant="body1">{messages.connectorDeleteAsk} "{selectedConnector?.connector_url}" ?</Typography>
                            <div style={{ paddingTop: "1em" }}>
                                <TextField
                                    label={messages.connectorDeleteReasonLabel}
                                    fullWidth
                                    multiline
                                    required
                                    rows={3}
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogAdminDeleteClose} variant="outlined">{messages.cancel}</Button>
                            <Tooltip title={reason === "" ? messages.fillAllMessage : ""} placement="top" arrow >
                                <div>
                                    <Button
                                        onClick={confirmAdminDelete}
                                        color="error"
                                        variant="outlined"
                                        disabled={reason === ""}
                                    >
                                        {messages.connectorListDelete}
                                    </Button>
                                </div>
                            </Tooltip>
                        </DialogActions>
                    </Dialog>
                    {/* Delete Request confirmation dialog */}
                    <Dialog open={dialogRequestDeleteOpen} onClose={handleDialogRequestDeleteClose}>
                        <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.connectorDeleteRequest}</Typography></DialogTitle>
                        <DialogContent>
                            <Typography variant="body1">{messages.connectorDeleteRequestAsk} "{selectedConnector?.connector_url}" ?</Typography>
                            <div style={{ paddingTop: "1em" }}>
                                <TextField
                                    label={messages.connectorDeleteReasonLabel}
                                    fullWidth
                                    multiline
                                    required
                                    rows={3}
                                    value={deleteRequestReason}
                                    onChange={(e) => setDeleteRequestReason(e.target.value)}
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogRequestDeleteClose} variant="outlined">{messages.cancel}</Button>
                            <Tooltip title={deleteRequestReason === "" ? messages.fillAllMessage : ""} placement="top" arrow >
                                <div>
                                    <Button
                                        onClick={confirmRequestDelete}
                                        color="error"
                                        variant="outlined"
                                        disabled={deleteRequestReason === ""}
                                    >
                                        {messages.conncectoDeleteRequestButton}
                                    </Button>
                                </div>
                            </Tooltip>
                        </DialogActions>
                    </Dialog>
                    {/* delete On request Dialog */}
                    <Dialog
                        open={dialogRequestAdminDeleteOpen}
                        onClose={handleDialogRequestAdminDeleteClose}
                        maxWidth={"lg"}
                    >
                        <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>{messages.connectorDeleteRequestAccept}</Typography></DialogTitle>
                        <DialogContent>
                            <Typography variant="body1">
                                {messages.connectorDeleteRequestAcceptAsk}
                                "{selectedConnector?.connector_url}"?
                            </Typography>

                            {/* Accept or Decline Buttons */}
                            <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                                <Button
                                    variant={deleteDecision === "true" ? "contained" : "outlined"}
                                    color="success"
                                    onClick={() => setDeleteDecision("true")}
                                    disabled={selectedConnector?.is_up === true}
                                >
                                    {messages.connectorDeleteAcceptButton}
                                </Button>
                                <Button
                                    variant={deleteDecision === "false" ? "contained" : "outlined"}
                                    color="error"
                                    onClick={() => setDeleteDecision("false")}
                                >
                                    {messages.connectorDeleteDeclineButton}
                                </Button>
                            </div>

                            {/* Reason Input (only shown when a deleteDecision is made) */}
                            {deleteDecision && (
                                <div style={{ paddingTop: "1em" }}>
                                    <TextField
                                        label={`Reason for ${deleteDecision === "true" ? "accepting" : "declining"} deletion`}
                                        fullWidth
                                        multiline
                                        required
                                        rows={3}
                                        value={deleteRequestAdminReason}
                                        onChange={(e) => setDeleteRequestAdminReason(e.target.value)}
                                        helperText={!deleteRequestAdminReason ? "Reason is required" : ""}
                                    />
                                </div>
                            )}
                            <DialogActions>
                                {/* Confirm Button (only enabled when a reason is provided) */}
                                <Button onClick={handleDialogRequestAdminDeleteClose} color="primary" variant="outlined">
                                    {messages.cancel}
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={confirmRequestAdminDelete}
                                    disabled={!deleteDecision || !deleteRequestAdminReason} // Disable if no suspendDecision or no reason
                                >
                                    {messages.confirm}
                                </Button>
                            </DialogActions>
                        </DialogContent>
                    </Dialog>
                </TableContainer>
                {/* Snackbar Component */}
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                        sx={{ width: "100%" }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Grid>
        </>
    );
}
